// extracted by mini-css-extract-plugin
export default {"antdOverrides":"overrides-module__izUV5"};